$(document).ready(function () {
  let p = $("body").attr("p");
  let a = $("body").attr("a");
  if (p === "events_self_service") {
    $(document).on("submit", ".product-search-form", function (e) {
      e.preventDefault();
      let formData = new FormData($(this)[0]);

      $.ajax({
        type: "POST",
        url: "/ajax/events_self_service/get_all_products",
        data: formData,
        enctype: "multipart/form-data",
        async: true,
        cache: false,
        processData: false,
        contentType: false,
      })
        .done(function (data) {
          if (data) {
            if (data.search) {
              $(".product-group").hide();
            } else {
              $(".product-group").show();
            }
            $("#product-list-with-category").html(data.html);
            $('[data-toggle="tooltip"]').tooltip(); // re-init
          }
        })
        .fail(function (data) {
          if (
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }
        });
    });

    $(document).on("click", ".category-nav-link", function (e) {
      const locationId = parseInt($("#location-products").data("location-id"));
      const formData = new FormData();
      $("#search_string").val("");
      const categoryName = $(this).data("category-name") || "";
      formData.append("search_string", "");
      formData.append("category_name", categoryName);
      formData.append("event_id", locationId);

      $.ajax({
        type: "POST",
        url: "/ajax/events_self_service/get_all_products",
        data: formData,
        enctype: "multipart/form-data",
        async: true,
        cache: false,
        processData: false,
        contentType: false,
      })
        .done(function (data) {
          if (data) {
            if (data.search) {
              $(".product-group").hide();
            } else {
              $(".product-group").show();
            }
            $("#product-group-").html(data.html);
            $('[data-toggle="tooltip"]').tooltip(); // re-init
          }
        })
        .fail(function (data) {
          if (
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }
        });
    });

    // Mobile search toggle functionality
    $(document).on(
      "click",
      "#mobile-search-toggle-dine-in-mobile",
      function (e) {
        $(".product-order-search-form-dine-in").slideToggle(300);
        // Focus on the search input when shown
        setTimeout(function () {
          if ($(".product-order-search-form-dine-in").is(":visible")) {
            $("#search_string").focus();
          } else {
            $("#clear-search-product-button").trigger("click");
          }
        }, 350);
      }
    );

    // $(document).on("click", "#clear-search-product-button-dine-in", function (e) {
    //   e.preventDefault();
    //   $(
    //     "#search_string,.product-order-search-form-dine-in #search_string"
    //   ).val("");
    //   $(this).addClass("d-none");
    //   const searchFormData = new FormData();
    //   const currentPage = parseInt($(this).attr("data-current-page")) || 1;
    //   const promo_code = $("#classic_promo_code").val();
    //   const postype = localStorage.getItem("postype") ?? null;
    //   searchFormData.append("search_string", "");
    //   searchFormData.append("event_id", locationId);
    //   searchFormData.append("page", currentPage - 1);
    //   searchFormData.append("product_category_id", "all");
    //   searchFormData.append("promo_code", promo_code);
    //   searchFormData.append("location_type", locationType);
    //   searchFormData.append("pos_type", postype);

    //   // searchProductList(searchFormData, "all");
    //   if ($(".search-product-form-container-mobile").length > 0) {
    //     $(".search-product-form-container-mobile").slideUp(300);
    //   }
    // });

    // Mobile search toggle functionality
    // $(document).on("click", "#mobile-search-toggle-dine-in-mobile", function (e) {
    //   const searchForm = $(".product-order-search-form-dine-in");

    //   if (searchForm.hasClass("show")) {
    //     searchForm.slideUp(300, function () {
    //       searchForm.removeClass("show");
    //     });
    //     $("#clear-search-product-button").trigger("click");
    //   } else {
    //     searchForm.addClass("show").slideDown(300);
    //     // Focus on the search input when shown
    //     setTimeout(function () {
    //       $("#search_string").focus();
    //     }, 350);
    //   }
    // });

    $(document).on("click", "#clear-search-product-button", function (e) {
      e.preventDefault();
      $("#search_string").val("");
      $(this).addClass("d-none");

      const searchFormData = new FormData();
      const currentPage = parseInt($(this).attr("data-current-page")) || 1;
      const promo_code = $("#classic_promo_code").val();
      const postype = localStorage.getItem("postype") ?? null;

      searchFormData.append("search_string", "");
      searchFormData.append("event_id", locationId);
      searchFormData.append("page", currentPage - 1);
      searchFormData.append("product_category_id", "all");
      searchFormData.append("promo_code", promo_code);
      searchFormData.append("location_type", locationType);
      searchFormData.append("pos_type", postype);

      // Uncomment when ready: searchProductList(searchFormData, "all");
    });
  }
});
